// extracted by mini-css-extract-plugin
export default {"popup_wrapper":"styles_popup_wrapper__dhmtv","popup":"styles_popup__VX1Ut","button":"styles_button__3C8Bv","popup_closeButton":"styles_popup_closeButton__Vx8hW"};